"use client";

import React from "react";
import { displayValue } from "../OtherBetsDropdown";

import { useOddsTrend } from "@/hooks/useOddsTrend";

const TotalCornerGridRow = ({ item, index }) => {
  const { 
    isUp: isUpOver, isDown: isDownOver, animating: animatingOver, animationClass: animationClassOver, successValueColorClass: colorOver, borderBgClass: bgOver 
  } = useOddsTrend(item.overTrend, item.over);
  
  const { 
    isUp: isUpUnder, isDown: isDownUnder, animating: animatingUnder, animationClass: animationClassUnder, successValueColorClass: colorUnder, borderBgClass: bgUnder 
  } = useOddsTrend(item.underTrend, item.under);

  return (
    <div key={index} className="grid grid-cols-3 gap-x-[15px] mb-[12px]">
      {/* Tổng */}
      <div className="market-line relative flex items-center justify-between border kbv-border-lighter rounded-lg h-[38px] px-2.5 mb-1 md:min-h-[48px] md:h-auto md:pl-3.5 md:pr-4 md:mb-0 bg-white cursor-pointer kbv-shadow-subtle hover:kbv-border-success transition-colors">
        <span className="odd-title md:text-[16px] text-[14px] kbv-text-main">
          {displayValue(item?.totalCorners)}
        </span>
      </div>

      {/* Tài */}
      <div className={`market-line relative flex items-center justify-between border rounded-lg h-[38px] px-2.5 mb-1 md:min-h-[48px] md:h-auto md:pl-3.5 md:pr-4 md:mb-0 cursor-pointer kbv-shadow-subtle transition-colors overflow-hidden ${bgOver} ${animationClassOver} ${animatingOver ? "" : "hover:border-[var(--theme-primary)] hover:bg-[var(--theme-accent)]"}`}>
        {isUpOver && animatingOver && (
          <div className="absolute left-[2px] top-[2px] z-10 animate-triangle-flash kbv-triangle-up-anim" />
        )}
        {isDownOver && animatingOver && (
          <div className="absolute right-[2px] bottom-[2px] z-10 animate-triangle-flash kbv-triangle-down-anim" />
        )}
        <span className="odd-title md:text-[16px] text-[14px] kbv-text-main">Tài</span>
        {item?.over ? (
          <span className="odd-icon">
            <div>
              <div className={`positive text-[16px] font-semibold ${colorOver}`}>
                {displayValue(item.over)}
              </div>
            </div>
          </span>
        ) : (
          <span className="text-[16px] kbv-text-main font-semibold">-</span>
        )}
      </div>

      {/* Xỉu */}
      <div className={`market-line relative flex items-center justify-between border rounded-lg h-[38px] px-2.5 mb-1 md:min-h-[48px] md:h-auto md:pl-3.5 md:pr-4 md:mb-0 cursor-pointer kbv-shadow-subtle transition-colors overflow-hidden ${bgUnder} ${animationClassUnder} ${animatingUnder ? "" : "hover:border-[var(--theme-primary)] hover:bg-[var(--theme-accent)]"}`}>
        {isUpUnder && animatingUnder && (
          <div className="absolute left-[2px] top-[2px] z-10 animate-triangle-flash kbv-triangle-up-anim" />
        )}
        {isDownUnder && animatingUnder && (
          <div className="absolute right-[2px] bottom-[2px] z-10 animate-triangle-flash kbv-triangle-down-anim" />
        )}
        <span className="odd-title md:text-[16px] text-[14px] kbv-text-main">Xỉu</span>
        {item?.under ? (
          <span className="odd-icon">
            <div>
              <div className={`positive text-[16px] font-semibold ${colorUnder}`}>
                {displayValue(item.under)}
              </div>
            </div>
          </span>
        ) : (
          <span className="text-[16px] kbv-text-main font-semibold">-</span>
        )}
      </div>
    </div>
  );
};

const OKTotalCornersOdds = ({ totalCornersOdds }) => {
  if (!Array.isArray(totalCornersOdds) || !totalCornersOdds.length) return null;

  return (
    <div>
      <div className="match-score px-0">
        <div className="flex flex-col">
          {totalCornersOdds.map((item, index) => (
            <TotalCornerGridRow key={index} item={item} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(OKTotalCornersOdds);